import axios from 'axios';
import { authLoginReq, req, getVerification, getpayQrcode } from './axiosFun';

// 登录接口
export const login = (params) => { return authLoginReq("post", "/api/noauth/login", params) };
// 验证码接口
export const verification = (params) => { return getVerification("get", "/api/noauth/verification", params) };
// 获取用户菜单
export const menu = (params) => { return axios.get("/api/menu?&token=" + localStorage.getItem('logintoken')).then(res => res.data) };
// 退出接口
export const loginout = () => {
  return req("post", "/api/noauth/logout")
};
// 修改密码接口
export const updatePwd = (params) => { return req("post", "/api/auth/update/pwd", params) };



// WEBPACK FOOTER //
// ./src/api/userMG.js